import React from "react";

export default function Footer(){

    return(

<       footer id="footer">
            <div className="container-fluid text-center">
                <nav style={{backgroundColor: '#444 !important'}}>
                    <ul id="copyright" className="nav navbar-nav">
                        <li><a href="http://www.e-softdevelopment.com" target="_blank"><span>&#169;Bruno
                                    LA MALFA || e-softdevelopment 2018</span></a></li>
                    </ul>
                </nav>
            </div>
        </footer>


    )
}